import { useEffect, useRef, useState }         from "react";
import { Grid, Icon, Typography }              from "@gupshup-frontend/gupshup-ts-components";

import {
  DATA_TESTID,
  ORDER_DETAILS,
  TEMPLATE_PREVIEW_DATA_TESTID,
}                                              from "./constant";
import styles                                  from "./style.module.css";

const OrderDetails = ({
  mediaUrl = "",
  bypassMediaUrlCheck = false,
  hidePreview = false,
  // Change #1: see Header.js for the same prop — replaces the old aliased
  // utilities/common import that read a zustand store which doesn't exist in this
  // repo. Note the
  // bypassMediaUrlCheck branch below returns WITHOUT setting validMediaUrl (unlike
  // Header.js, which sets it to mediaUrl) — that asymmetry is in the source too, kept
  // as-is rather than "fixed".
  validateMediaUrl = async (mediaUrl) => mediaUrl,
}) => {

  const headerRef = useRef(null);

  const [validMediaUrl, setValidMediaUrl] = useState('');
  const [isVisible, setIsVisible]         = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      setIsVisible(entry.isIntersecting);
    },{ threshold: 0.1 });

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => {
      if (headerRef.current) {
        observer.unobserve(headerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!mediaUrl) {
      return;
    }
    if (bypassMediaUrlCheck) {
      return;
    }
    if (isVisible && !hidePreview) {
      validateMediaUrl(mediaUrl).then((isValid) => {
        setValidMediaUrl(isValid || '');
      });
    }
  },[mediaUrl, isVisible]);

  const dataTestId = `${DATA_TESTID}-image-${mediaUrl ? "dynamic" : "static"}`;

  return (
    <Grid className = {styles.orderDetailsPanel} ref = {headerRef} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_DETAILS_PANEL}>
      <Grid>
        <Typography className = {styles.orderId} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_DETAILS_ORDERID}>
          {ORDER_DETAILS.ORDERID}
        </Typography>
      </Grid>
      <Grid className = {styles.orderDetailsList} >
        <Icon
          size       = {65}
          alt        = "Order Details Icon"
          dataTestId = {dataTestId}
          customPath = {mediaUrl && !hidePreview && validMediaUrl ? validMediaUrl : ORDER_DETAILS.ICONPATH}
        />
        <Grid>
          <Typography variant = "body2" fontWeight = {500} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_DETAILS_HEADER}>
            {ORDER_DETAILS.HEADER}
          </Typography>
          <Typography className = {styles.orderSubHeader} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_DETAILS_SUBHEADER}>
            {ORDER_DETAILS.SUBHEADER}
          </Typography>
        </Grid>
      </Grid>
      <Grid display = "flex" justifyContent = "space-between" >
        <Typography variant = "caption" data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_DETAILS_TOTAL}>
          {ORDER_DETAILS.TOTAL}
        </Typography>
        <Typography variant = "caption" fontWeight = {500} data-testid = {TEMPLATE_PREVIEW_DATA_TESTID.ORDER_DETAILS_AMOUNT}>
          {ORDER_DETAILS.AMOUNT}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default OrderDetails;
